import { AfterViewInit, Component } from '@angular/core';
import { Observable, isObservable } from 'rxjs';
import { first } from 'rxjs/operators';
import {
  SerializedTextFilter,
  IFloatingFilter,
  IFloatingFilterParams
} from 'ag-grid-community';

export interface DropdownFloatingFilterChange {
  model: SerializedTextFilter;
}

export interface DropdownFloatingFilterParams
  extends IFloatingFilterParams<
    SerializedTextFilter,
    DropdownFloatingFilterChange
  > {
  filterOptions: string[] | Observable<string[]>;
  defaultOption: string;
}

@Component({
  template: `
    <select
      class="form-control"
      [(ngModel)]="currentValue"
      (ngModelChange)="valueChanged()"
    >
      <option value="">{{ params.defaultOption }}</option>
      <option
        *ngFor="let param of params?.filterOptions"
        [value]="param"
        [textContent]="param"
      >
      </option>
    </select>
  `
})
export class DropdownFloatingFilterComponent
  implements
    IFloatingFilter<
      SerializedTextFilter,
      DropdownFloatingFilterChange,
      DropdownFloatingFilterParams
    >,
    AfterViewInit {
  public params: DropdownFloatingFilterParams;
  public currentValue = '';

  public agInit(params: DropdownFloatingFilterParams): void {
    this.params = params;

    if (params && isObservable(params.filterOptions)) {
      params.filterOptions
        .pipe(first())
        .subscribe(
          (filterOptions: string[]) =>
            (this.params.filterOptions = filterOptions)
        );
    }
  }

  public ngAfterViewInit(): void {
    this.valueChanged();
  }

  public valueChanged(): void {
    this.params.onFloatingFilterChanged({ model: this.buildModel() });
  }

  public onParentModelChanged(parentModel: SerializedTextFilter): void {
    if (!parentModel) {
      this.currentValue = '';
    }
  }

  public buildModel(): SerializedTextFilter {
    if (this.currentValue === '') {
      return null;
    }

    return {
      filterType: 'agTextColumnFilter',
      type: 'equals',
      filter: this.currentValue
    };
  }
}
